module.exports = __webpack_public_path__ + "static/media/gnosis_safe.18b63002.png";